// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"w5-z","colorTextValue":"x5-z","swatches":"y5-z","collapseLink":"z5-z","isCollapsed":"A5-z","dropdown":"B5-z","disabled":"C5-z"};